import { apiInitialState } from '../../../utils/reduxOperations';

export function Default() {
    return {
        getUserProfileApi: apiInitialState()
    };
}
